import { supabase } from './supabase';

/**
 * Tworzenie i weryfikacja sesji platnosci Stripe'a mieszkalo kiedys tutaj i wolalo
 * api.stripe.com prosto z przegladarki, z sekretnym kluczem w naglowku Authorization.
 * Nic tych funkcji nie wywolywalo, wiec bundler je wycinal i klucz nie trafial na produkcje -
 * ale wystarczylo podpiac je pod przycisk, zeby wyciekl do kazdego odwiedzajacego.
 *
 * Zostala tylko operacja, ktora rusza wylacznie nasza baze. Gdyby automatyczne uzupelnianie
 * kredytow mialo wrocic, checkout nalezy zrobic funkcja brzegowa (jest juz
 * create-stripe-checkout i stripe-auto-charge), a nie z poziomu frontu.
 */

export async function cancelAutoReplenishment(userId: string): Promise<void> {
  try {
    // Update user settings
    const { error: updateError } = await supabase
      .from('user_settings')
      .update({
        auto_replenish_enabled: false
      })
      .eq('user_id', userId);

    if (updateError) throw updateError;
  } catch (error) {
    console.error('Error cancelling auto-replenishment:', error);
    throw error;
  }
}
